const MAX_HISTORY = 80;

export function createNoteEditorHistory() {
  const undoStack = [];
  const redoStack = [];

  return {
    push(blocks) {
      undoStack.push(JSON.stringify(blocks));
      if (undoStack.length > MAX_HISTORY) undoStack.shift();
      redoStack.length = 0;
    },
    undo(current) {
      if (!undoStack.length) return null;
      redoStack.push(JSON.stringify(current));
      return JSON.parse(undoStack.pop());
    },
    redo(current) {
      if (!redoStack.length) return null;
      undoStack.push(JSON.stringify(current));
      return JSON.parse(redoStack.pop());
    },
    clear() {
      undoStack.length = 0;
      redoStack.length = 0;
    },
  };
}
